export default __webpack_public_path__ + "static/media/gel-side.5172c4ff.svg";